import React, { createContext, useContext } from 'react'

const EnvironmentContext = createContext(null)

export const ENVIRONMENTS = {
  PRODUCTION: 'production',
  DEVELOPMENT: 'development'
}

export function EnvironmentProvider({ children }) {
  // Environment is always production — the dev/test switcher has been removed
  // Clean up stale localStorage from the old switcher
  if (typeof window !== 'undefined') {
    localStorage.removeItem('admin_environment')
  }

  const environment = ENVIRONMENTS.PRODUCTION
  const isProduction = true

  const switchEnvironment = () => {
    // No-op: environment switching is disabled
  }

  return (
    <EnvironmentContext.Provider value={{ environment, switchEnvironment, isProduction }}>
      {children}
    </EnvironmentContext.Provider>
  )
}

export function useEnvironment() {
  const context = useContext(EnvironmentContext)
  if (!context) {
    throw new Error('useEnvironment must be used within an EnvironmentProvider')
  }
  return context
}
